// custom-tooltip.js
import React from 'react';
import { Tooltip, withStyles } from '@material-ui/core';

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.black,
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
}))(Tooltip);

export default CustomTooltip;
